import React from 'react';
import { LeadEditModal } from './edit';
import { useDetails } from './useDetails';
import { PERMISSIONS } from 'constants/permissions';
import { EditIconButton } from 'components/common/icons';
import { Button, Col, MultiLineEllipsisText, Row, Typography } from 'components';
import { HasAccess } from 'components/common/accessControl';
import styles from './styles.module.scss';
import { Assignment } from './assignment';
import { AssignmentEditModal } from './assignment/edit';
import { LeadStatusBadge } from 'components/common/StatusBadge/LeadStatusBadge';
import { ContactPersons } from './contactPersons';
import { Skeleton } from 'antd';
import { convertEnumsToReadableStrings } from 'utils/helpers';

export const Details = React.memo(() => {
  const {
    onUpdateDetailsClick,
    onUpdateAssignmentClick,
    leadDetails,
    openDetailsEditModal,
    openAssignmentEditModal,
    onCloseDetailsEditModal,
    onCloseAssignmentEditModal,
    adminUsersMapping,
    assignmentData,
    isLoading,
    isFinalStatus,
  } = useDetails();

  if (isLoading) {
    return (
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Skeleton active />
        </Col>
        <Col span={24}>
          <Skeleton active />
        </Col>
        <Col span={24}>
          <Skeleton active />
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row gutter={[0, 16]}>
        <Col span={24} className={styles.main_info}>
          <Row justify={'space-between'} wrap={false}>
            <Col span={20}>
              <Row gutter={[0, 4]}>
                <Col span={24} style={{ marginTop: 5 }} className={styles.legal_name}>
                  <Typography.Text ellipsis={{ tooltip: true }} className={styles.name}>
                    ID: {leadDetails.uuid}
                  </Typography.Text>
                </Col>
                <Col span={24}>{leadDetails?.status ? <LeadStatusBadge type={leadDetails?.status} /> : ''}</Col>
              </Row>
            </Col>
            <Col>
              <HasAccess role={PERMISSIONS.leads.lead.write}>
                {!isFinalStatus ? (
                  <Button type={'link'} icon={<EditIconButton />} onClick={onUpdateDetailsClick} />
                ) : (
                  ''
                )}
              </HasAccess>
            </Col>
          </Row>
          <Row className={'margin-t-4'}>
            {leadDetails?.rejectionReason ? (
              <Col span={24} style={{ marginTop: 8 }}>
                <Typography.Text ellipsis={{ tooltip: true }} style={{ fontSize: 16 }}>
                  {convertEnumsToReadableStrings(leadDetails?.rejectionReason)}
                </Typography.Text>
              </Col>
            ) : (
              ''
            )}

            <Col span={24} style={{ marginBottom: 8 }}>
              {leadDetails?.comments ? (
                <Typography.Text ellipsis={{ tooltip: true }}>{leadDetails?.comments}</Typography.Text>
              ) : (
                ''
              )}
            </Col>
            <Col span={24}>
              <Row className={'gap-8'} wrap={false} align={'middle'}>
                <Typography.Text className={'font-size-12'} style={{ color: '#99A0AE' }}>
                  {leadDetails.formattedCreatedDate}
                </Typography.Text>
                <Typography.Text className={'font-size-12'} style={{ color: '#99A0AE' }}>
                  {leadDetails.formattedLastModifiedDate}
                </Typography.Text>
              </Row>
            </Col>
            <Col span={12}>
              <Row align={'middle'} style={{ marginTop: 12 }}>
                <Typography.Text ellipsis={{ tooltip: true }} type={'secondary'}>
                  CREATED BY <br />
                  {adminUsersMapping?.[leadDetails?.createdBy]?.firstName || ''}{' '}
                  {adminUsersMapping?.[leadDetails?.createdBy]?.lastName || ''}
                </Typography.Text>
              </Row>
            </Col>
            <Col span={12}>
              <Row align={'middle'} style={{ marginTop: 12 }}>
                <Typography.Text ellipsis={{ tooltip: true }} type={'secondary'}>
                  LAST UPDATED BY <br />
                  {adminUsersMapping?.[leadDetails?.lastModifiedBy]?.firstName || ''}{' '}
                  {adminUsersMapping?.[leadDetails?.lastModifiedBy]?.lastName || ''}
                </Typography.Text>
              </Row>
            </Col>
            {leadDetails.clientRequestNumber ? (
              <Col className={'margin-t-12'} span={24}>
                <Typography.Text ellipsis={{ tooltip: true }} type={'secondary'}>
                  Client Request Number: {leadDetails.clientRequestNumber}
                </Typography.Text>
              </Col>
            ) : (
              ''
            )}
          </Row>
        </Col>
        <ContactPersons />
        <Assignment
          isFinalStatus={isFinalStatus}
          assignmentData={assignmentData}
          onUpdateAssignmentClick={onUpdateAssignmentClick}
        />
        <Col span={24}>
          <MultiLineEllipsisText subTitle={'Additional Notes:'} text={leadDetails?.client?.additionalNotes} />
        </Col>
      </Row>
      <LeadEditModal open={openDetailsEditModal} onCancel={() => onCloseDetailsEditModal()} />
      <AssignmentEditModal open={openAssignmentEditModal} onCancel={() => onCloseAssignmentEditModal()} />
    </>
  );
});
